import React from 'react';
import { Col } from '@yme/atoms/grid';
import { useWindowSize } from '@yme/common/hooks';
import { FilterMenuItemStyled } from '@yme/molecules/filter-dropdown/styled';
export function DatePickerWrapper({ children }) {
    const { isInfiniteDesktopView } = useWindowSize();
    if (isInfiniteDesktopView) {
        return React.createElement(Col, { lg: 4 }, children);
    }
    return React.createElement(FilterMenuItemStyled, null, children);
}
